// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-content[data-v-6bd4d80d]{background-color:#fff;border:1px solid #e3e7ed;border-radius:8px;padding:24px;position:relative;transition:width .2s linear}.dialog-content .dialog-close-button[data-v-6bd4d80d]{margin:0;position:absolute;right:16px;top:16px;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
